import { Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Modes } from "./types";

const dialogContentStyle = {
  width: "100%",
  marginBottom: 0,
};

export interface UserDocumentDialogComponentProps {
  isOpen: boolean
  onCancel: () => void
  getModeContentTitle: () => string | JSX.Element
  getModeContent: () => JSX.Element
  mode: Modes,
}

export function UserDocumentDialogComponent({
  isOpen,
  onCancel,
  mode,
  getModeContentTitle,
  getModeContent
}: UserDocumentDialogComponentProps): JSX.Element {
  return (
    <Dialog
      fullWidth
      maxWidth={mode === Modes.delete ? "sm" : "lg"}
      open={isOpen}
      onClose={onCancel}
    >
      <DialogContent sx={dialogContentStyle}>
        {/* Putting the heading in a dialog title element instead of right here messes up padding and covers the top of the content */}
        <div id="responsive-dialog-title" style={{ textAlign: "center" }}>
          {<Typography variant="h3" style={{ padding: "0.5rem" }} >{getModeContentTitle()}</Typography>}
          {onCancel ? (
            <IconButton
              aria-label="close"
              sx={{
                position: "absolute",
                right: "1rem",
                top: 0,
                color: "grey.500",
              }}
              onClick={onCancel}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </div>
        {getModeContent()}
      </DialogContent>
    </Dialog>
  )
}